/**
 * Slug helper for auto-generating stable identifiers from human-readable
 * labels. Used by the email template editor when the admin types a Name
 * - the slug is derived automatically and can be overridden via the
 * Advanced section.
 */

export function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64)
}
